import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import { NAV, HEADER } from './config-layout';
import MenuIcon from '@mui/icons-material/Menu';
import { useResponsive } from '../../../hooks/use-responsive';
import AccountPopover from './common/account-popover';
// ----------------------------------------------------------------------
interface Props {
    onOpenNav: () => void; // Define the type of onOpenNav
}

export default function Header({ onOpenNav }: Props) {
    const theme = useTheme();

    const lgUp = useResponsive('up', 'lg', 'sm');

    const renderContent = (
        <>
            {!lgUp && (
                <IconButton onClick={onOpenNav} sx={{ mr: 1 }}>
                    <MenuIcon />
                </IconButton>
            )}

            <Box sx={{ flexGrow: 1 }} />

            <Stack direction="row" alignItems="center" spacing={1}>
                <AccountPopover />
            </Stack>
        </>
    );

    return (
        <AppBar
            sx={{
                background: 'white',
                boxShadow: 'none',
                // zIndex: '0',
                height: HEADER.H_MOBILE,
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(lgUp && {
                    width: `calc(100% - ${NAV.WIDTH + 1}px)`,
                    height: HEADER.H_DESKTOP,
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 5 },
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}

Header.propTypes = {
    onOpenNav: PropTypes.func,
};
